/* eslint-disable class-methods-use-this */

import Service from './Service';

class ComponentsService extends Service {
  constructor() {
    super('components');
  }

  getFieldsTableComponents() {
    return [
      {
        key: 'description',
        label: 'Descrição',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'unit',
        label: 'Unidade de medida',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'price',
        label: 'Custo ',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'actions',
        label: 'Ações',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
    ];
  }

  getFieldsTableComponentsInverter() {
    return [
      {
        key: 'description',
        label: 'Descrição',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'quantity',
        label: 'Quantidade',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'price',
        label: 'Custo ',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
    ];
  }
}

const componentsService = new ComponentsService();
export default componentsService;
